import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchNutShapes, createNutShape, deleteNutShape, updateNutShape } from '../../common/jsonstore';
import { NutShape } from '../../common/model';
import { AppState } from '../../redux/store/rootReducer';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { signOut } from '../../services/localStorage';
import { handleError } from '../../services/messageApiService';

export interface IAuthentication {
  NutShape: NutShape[];
  success: any;
  isProcessingComplete: boolean;
}

const initialState: IAuthentication = { NutShape: [], success: {}, isProcessingComplete: false };

const NutShapeSlice = createSlice({
  name: 'NutShapes',
  initialState,
  reducers: {
    receiveNutShape: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        NutShape: action.payload,
        isProcessingComplete: false
      };
    },
    success: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        success: action.payload,
        isProcessingComplete: true
      };
    }
  }
});


export const loadNutShapes = (): any => async (dispatch: AppDispatch) => {
  if (isTokenExpired()) {
    const NutShapes = await fetchNutShapes().then((res: any) => {
      dispatch(NutShapeSlice.actions.receiveNutShape(res))
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Nut shape data not loaded';
        handleError(msg);
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const addNutShape = (newNutShape: NutShape): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const res = await createNutShape(newNutShape).then((resp) => {
      dispatch(NutShapeSlice.actions.receiveNutShape([...getState().NutShapes.NutShape, resp.data[0]]));
      dispatch(NutShapeSlice.actions.success({ 'sts': true, data: resp?.msg }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Nut shape data not added';
        dispatch(NutShapeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const modifyNutShape = (newNutShape: NutShape, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    const respp = await updateNutShape(newNutShape, id).then((res: any) => {
      const updatedFittingSizes = getState().NutShapes.NutShape.map(el => (el.id === id ? res : el))
      dispatch(NutShapeSlice.actions.receiveNutShape(updatedFittingSizes));
      dispatch(NutShapeSlice.actions.success({ 'sts': true, data: 'Nut shape data updated successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Nut shape data not updated ';
        dispatch(NutShapeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const removeNutShape = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (isTokenExpired()) {
    deleteNutShape(id).then((res: any) => {
      const updatedNutShapes = getState().NutShapes.NutShape.filter((item) => item.id !== id);
      dispatch(NutShapeSlice.actions.receiveNutShape(updatedNutShapes));
      dispatch(NutShapeSlice.actions.success({ 'sts': true, data: 'Nut shape data deleted successfully' }));
    }).catch(err => {
      if (err?.response?.data?.message?.includes("access token")) {
        handleError(err.response.data.message);
        setTimeout(() => { return signOut(); }, 500);
      } else {
        let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Nut shape data not deleted';
        dispatch(NutShapeSlice.actions.success({ 'sts': false, data: msg }));
      }
    })
  } else {
    handleError('Token is expired');
    setTimeout(() => { return signOut(); }, 500);
  }
}

export const updateSts = (data: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
  dispatch(NutShapeSlice.actions.success(data));
}

export default NutShapeSlice.reducer;
